module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.svg?ff4da5ed81cdfe2b2e68d6dd9978d96e";